import { render } from "./TableRowActions.vue?vue&type=template&id=2f96ecae&scoped=true"
import script from "./TableRowActions.vue?vue&type=script&lang=js"
export * from "./TableRowActions.vue?vue&type=script&lang=js"

import "./TableRowActions.vue?vue&type=style&index=0&id=2f96ecae&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f96ecae"]])

export default __exports__